import React from "react";
import "./style.css"
import { useListDashboardCountQuery } from "../../Services/DasboardAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faSitemap, faHandHoldingDollar, faCartPlus } from "@fortawesome/free-solid-svg-icons";

function Index() {
  const { data, error, isLoading } = useListDashboardCountQuery();

  if (isLoading) return <div class="loader"></div>;
  if (error) return <p>Failed to load Data</p>;

  return (
    <div>

      <div className='dasboard-items'>
        <div className='row'>
          <div className='col-md-4 col-sm-12 col-lg-4'>

            <div className='card-count-items'>
              <div className="dashboard-item-icon"><FontAwesomeIcon icon={faUsers} className="mx-2 clr-yelllow" /></div>
              <p className='count m-0 p-0'>{data?.data?.users}</p>
              <h5>Total Users</h5>

            </div>
          </div>

          <div className='col-md-4 col-sm-12 col-lg-4'>
            <div className='card-count-items'>
              <div className="dashboard-item-icon"><FontAwesomeIcon icon={faSitemap} className="mx-2 clr-violet" /></div>
              <p className='count m-0 p-0'>{data?.data?.products}</p>
              <h5>Total Products</h5>

            </div>
          </div>

          <div className='col-md-4 col-sm-12 col-lg-4'>
            <div className='card-count-items'>
              <div className="dashboard-item-icon"><FontAwesomeIcon icon={faCartPlus} className="mx-2 clr-blue" /></div>
              <p className='count m-0 p-0'>{data?.data?.orders}</p>
              <h5>Total Orders</h5>

            </div>
          </div>

          <div className='col-md-4 col-sm-12 col-lg-4'>
            <div className='card-count-items'>
              <div className="dashboard-item-icon"><FontAwesomeIcon icon={faHandHoldingDollar} className="mx-2 clr-green" /></div>
              <p className='count m-0 p-0'>$ {data?.data?.amount}</p>
              <h5>Total Earnings</h5>

            </div>
          </div>

        </div>

      </div>
    </div>

  )
}

export default Index